export default __webpack_public_path__ + "static/media/wetez_governance.87f4b430.svg";